// Path calculation utilities for CustomMode

// Calculate distance between two points using Manhattan formula
export const calculateManhattanDistance = (point1, point2) => {
  // Convert degree differences to approximate kilometers
  const lat_diff = Math.abs(point2.latitude - point1.latitude);
  const lng_diff = Math.abs(point2.longitude - point1.longitude);
  
  // Approximate conversion: 1 degree ≈ 111 km
  const lat_km = lat_diff * 111.0;
  const lng_km = lng_diff * 111.0;
  
  // Manhattan distance in kilometers
  return lat_km + lng_km;
};

// Calculate total path distance
export const calculatePathDistance = (customPath) => {
  if (customPath.length < 2) return 0;
  
  let distance = 0;
  for (let i = 0; i < customPath.length - 1; i++) {
    const point1 = customPath[i];
    const point2 = customPath[i + 1];
    distance += calculateManhattanDistance(point1, point2);
  }
  
  return distance.toFixed(2);
};

// Get remaining points that are not yet in the path
export const getRemainingPoints = (availablePoints, customPath) => {
  if (customPath.length === 0) return availablePoints;
  
  return availablePoints.filter(point => 
    !customPath.some(pathPoint => pathPoint.id === point.id)
  );
}; 